import { render, staticRenderFns } from "./SchoolTeacherForm.vue?vue&type=template&id=bad7a640"
import script from "./SchoolTeacherForm.vue?vue&type=script&lang=js"
export * from "./SchoolTeacherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports